


// banner slider
$('.ibak-banner-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
   prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 19L1 10L10 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  nextArrow: '<button class="slick-next" aria-label="Next" type="button"><svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 19L10 10L1 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        dots: true,
        arrows: false,
      }
    }
  ]
});


// video section 
   $('.vdo-btn-click').click(function(){
      $(this).parent().parent(".thumb-btn-wrap").hide();
      $(this).parent().parent().siblings(".vdo-sec").children("#vdo-play").trigger('play');
   });


$('.icon-text-slider').slick({
  dots: true,
  arrows: true, // Set to true to enable prev/next arrows
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


 setTimeout(function () {
    $('.ibak-logo').attr('target', '_blank');
  }, 1200);



//ramvac-banner-slider
$('.ramvac-banner-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  fade: true
});


